import React from "react";
import { useForm } from "react-hook-form";

const CustomerDependentsForm = ({
  customer,
  updateCustomer,
  setDisplayDependentsModal,
  callback,
  ...props
}) => {
  const { register, handleSubmit, errors } = useForm();

  const onSubmit = (data) => {
    const updatedCustomer = {
      id: customer.id,
      _version: customer._version,
      dependents: [data, ...(customer.dependents || [])],
    };
    updateCustomer(updatedCustomer, callback);
    setDisplayDependentsModal(false);
  };

  return (
    <div className="mx-auto mt-10 max-w-sm">
      <div className="bg-gray-50 p-4 shadow">
        <div className="block text-center font-medium leading-5 text-gray-700 my-1">
          Member
        </div>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="p-1">
            <label
              htmlFor="givenName"
              className="block text-sm font-medium leading-5 text-gray-700"
            >
              First name
            </label>
            <input
              id="givenName"
              name="givenName"
              ref={register({ required: true })}
              className="mt-1 form-input block w-full py-2 px-3 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
            />
            {errors.givenName && (
              <p className="text-red-500 text-xs mt-1">
                First name is required
              </p>
            )}
          </div>

          <div className="p-1">
            <label
              htmlFor="familyName"
              className="block text-sm font-medium leading-5 text-gray-700"
            >
              Last name
            </label>
            <input
              id="familyName"
              name="familyName"
              ref={register({ required: true })}
              className="mt-1 form-input block w-full py-2 px-3 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
            />
            {errors.familyName && (
              <p className="text-red-500 text-xs mt-1">Last name is required</p>
            )}
          </div>

          <div className="flex px-4 pt-3 gap-3 justify-end">
            <span className="inline-flex rounded-md shadow-sm">
              <button
                onClick={() => setDisplayDependentsModal(false)}
                className="inline-flex justify-center py-2 px-4 border border-transparent text-sm leading-5 font-medium rounded-md text-white bg-red-600 hover:bg-red-500 focus:outline-none focus:border-red-700 focus:shadow-outline-red active:bg-red-700 transition duration-150 ease-in-out"
              >
                Cancel
              </button>
            </span>
            <span className="inline-flex rounded-md shadow-sm">
              <button
                type="submit"
                className="inline-flex justify-center py-2 px-4 border border-transparent text-sm leading-5 font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo active:bg-indigo-700 transition duration-150 ease-in-out"
              >
                Save
              </button>
            </span>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CustomerDependentsForm;
